import { render, staticRenderFns } from "./AIdraw.vue?vue&type=template&id=5e6806ea&scoped=true"
import script from "./AIdraw.vue?vue&type=script&lang=js"
export * from "./AIdraw.vue?vue&type=script&lang=js"
import style0 from "./AIdraw.vue?vue&type=style&index=0&id=5e6806ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6806ea",
  null
  
)

export default component.exports